import type { U3204ConversationSearchRow } from '../U3204Service';
import {
  groupConversationsByDay,
  type U3204ConversationDayBucket,
  type U3204GroupConversationsByDayOptions,
} from './u3204GroupConversationsByDay';

export type U3204ConversationSidebarGroupKey = 'pinned' | U3204ConversationDayBucket;

export interface U3204ConversationSidebarGroup {
  key: U3204ConversationSidebarGroupKey;
  labelKey: string;
  conversations: U3204ConversationSearchRow[];
}

function u3204SortPinnedConversations(
  conversations: U3204ConversationSearchRow[],
): U3204ConversationSearchRow[] {
  return [...conversations].sort((a, b) => {
    const oa = a.pinnedOrder ?? Number.MAX_SAFE_INTEGER;
    const ob = b.pinnedOrder ?? Number.MAX_SAFE_INTEGER;
    if (oa !== ob) return oa - ob;
    return (b.pinnedAt ?? '').localeCompare(a.pinnedAt ?? '');
  });
}

export function groupConversationsForSidebar(
  conversations: U3204ConversationSearchRow[],
  options?: U3204GroupConversationsByDayOptions,
): U3204ConversationSidebarGroup[] {
  const pinnedItems = u3204SortPinnedConversations(conversations.filter((c) => c.pinned));
  const rest = conversations.filter((c) => !c.pinned);
  const dayGroups = groupConversationsByDay(rest, options);

  const groups: U3204ConversationSidebarGroup[] = [];

  if (pinnedItems.length > 0) {
    groups.push({
      key: 'pinned',
      labelKey: 'pinned',
      conversations: pinnedItems,
    });
  }

  for (const dayGroup of dayGroups) {
    groups.push({
      key: dayGroup.bucket,
      labelKey: dayGroup.bucket,
      conversations: dayGroup.conversations,
    });
  }

  return groups;
}
